
import { Component, Prop, Vue } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { addAnotherSection } from "@/subapps/onboarding/lib/pages";
import { TreeNode } from "@/types/tree";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    Icon
  }
})
export default class NodeOnboardingAddSectionButton extends Vue {
  @Prop({ required: true })
  element!: TreeNode;

  addSection() {
    logEvent("Onboarding", {
      action: "onboarding_app_ui_interaction",
      type: "node_add_section_button"
    });

    addAnotherSection(this.element);
  }
}
